import { RelationEmpty, RelationSchema } from "$lib/data/schema/_relation"
import { z } from "zod/v4"

export const EventSchema = z.object({
  id: z.number().default(0),
  number: z.string().default(""),
  date: z.string().default(""),
  name: z.string().default(""),
  type: RelationSchema.default(RelationEmpty),
  sales_person: RelationSchema.default(RelationEmpty),
  datetime_start: z.string().default(""),
  datetime_end: z.string().default(""),
  customer: RelationSchema.default(RelationEmpty),
  address: z.string().default(""),
  pic_name: z.string().default(""),
  participant_count: z.string().default(""),
  description: z.string().default(""),
  document_url: z.string().default(""),
})

export type Event = z.infer<typeof EventSchema>

export const EventEmpty = EventSchema.parse({})
